import type { FC } from "react";

import { TextField } from "@kivra/react-components";

interface OwnProps {
  label: string;
  value: string;
}

export const PresetFormValue: FC<OwnProps> = ({ label, value }) => (
  <TextField label={label} value={value} readOnly disabled />
);
